var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isPC)?_c('Web'):_c('Mobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }